import Navbar from './components/Navbar/Navbar';
import ScrollToTop from './components/Navbar/scroll';

import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import Home from './Pages/Home';
import Courses from './Pages/Course';
import About from './Pages/About';
import Campus from './Pages/Campus';
import Contact from './Pages/contact';
import Coursedetails from './Pages/CoueseDetails/Coursedetails';
import PlacementPortal from './components/Placement/Placement';

const router = createBrowserRouter(
  [
    {
      path: '/',
      element: (
        <>
          <ScrollToTop />
          <Navbar />
          <Home />
        </>
      ),
    },
    {
      path: '/courses',
      element: (
        <>
          <ScrollToTop />
          <Navbar />
          <Courses />
        </>
      ),
    },
    {
      path: '/about',
      element: (
        <>
          <ScrollToTop />
          <Navbar />
          <About />
        </>
      ),
    },
    {
      path: '/campus',
      element: (
        <>
          <ScrollToTop />
          <Navbar />
          <Campus />
        </>
      ),
    },
    {
      path: '/placement',   // ✅ CORRECT PATH
      element: (
        <>
          <ScrollToTop />
          <Navbar />
          <PlacementPortal />
        </>
      ),
    },
    {
      path: '/contact',
      element: (
        <>
          <ScrollToTop />
          <Navbar />
          <Contact />
        </>
      ),
    },
    {
      path: '/course/:id',
      element: (
        <>
          <ScrollToTop />
          <Navbar />
          <Coursedetails />
        </>
      ),
    },
    // 🚨 ADDED: Catch-All 404 Route to prevent the "Hey developer" error crash
    {
      path: '*',
      element: (
        <>
          <ScrollToTop />
          <Navbar />
          <div style={{ textAlign: 'center', padding: '150px 20px', color: 'white', minHeight: '60vh' }}>
            <h1 style={{ fontSize: '3rem', marginBottom: '20px', color: '#06b6d4' }}>404</h1>
            <h2>Oops! Page Not Found</h2>
            <p style={{ color: '#94a3b8', marginTop: '10px', marginBottom: '30px' }}>
              Macha, the page you are looking for doesn't exist or has been moved.
            </p>
            <a href="/" style={{ padding: '10px 24px', backgroundColor: '#3b82f6', color: 'white', borderRadius: '8px', textDecoration: 'none', fontWeight: 'bold' }}>
              Go Back Home
            </a>
          </div>
        </>
      ),
    },
  ],
  {
    future: {
      v7_relativeSplatPath: true,
      v7_startTransition: true, // Added to prevent future React Router warnings
    },
  }
);

function App() {
  return <RouterProvider router={router} />;
}

export default App;